import { query } from '~/api/tiles';

export async function queryLayer(layerId: string, bounds: number[][], z: number) {
  const data = await query(layerId, bounds.flat() as [number, number, number, number], z);

  return data;
}
